"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeMemberDtoTestData = void 0;
function makeMemberDtoTestData(userKey = "1", votingMember = true, manager = false) {
    return {
        userId: `user${userKey}-id`,
        modifiedDate: 123,
        isVotingMember: votingMember,
        isManager: manager,
        isReady: false,
        vote: [
            {
                nominationId: "nomination2-id",
                excluded: false,
                vetoed: false
            },
            {
                nominationId: "nomination1-id",
                excluded: false,
                vetoed: true
            }
        ]
    };
}
exports.makeMemberDtoTestData = makeMemberDtoTestData;
;
//# sourceMappingURL=member.dto.spec.data.js.map